import React from "react";
import Alert from "react-s-alert";
import FooterComponent from '../components/Footer/footer-new';
import HeaderComponent from '../components/Header/new-header';
import Sidebar from "./sidebar";

const SidebarLayout = ({ children, locale, setLocale, user }) => {
  const isUser = user.profile.level.filter(f => f === 'user').length;
  const speakerDataPage = document.location.pathname.includes('/speaker-data/');
  
  if(speakerDataPage) {
    return <div className="h-100">
      <HeaderComponent locale={locale} setLocale={setLocale} />
      {children}
      <Alert stack={{ limit: 1 }}  />
      <FooterComponent />
    </div>
  }

  return (
    <div className="h-100">
      {isUser && <Sidebar locale={locale} setLocale={setLocale} />}
      <div className="page-wrapper relative h-100">
        {/* <div className="locale-dd"><LocaleDropdown locale={locale} setLocale={setLocale} /></div> */}
        {children}
      </div>
      <Alert stack={{ limit: 1 }}  />
    </div>
  );
};

export default SidebarLayout;
